import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobCriteria } from 'src/app/common';
import { Utility } from 'src/app/core/common';
import { PersianDate } from 'src/app/core/persian-date';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: './agent-detail.component.html',
  styleUrls: ['./agent-detail.component.scss']
})
export class AgentDetailComponent implements OnInit {
  constructor(private userService: UserService, private sharedService: SharedService, private route: ActivatedRoute,
    private spinner: SpinnerService) {
  }
  Utility = Utility;

  user: any;

  code: number;

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.params.subscribe(async params => {
        this.code = +params['code'];
        await this.load();
        resolve();
      });
    });
  }

  criteria: JobCriteria = new JobCriteria();
  private async load() {
    if (!this.code) return;
    this.spinner.show('load');
    this.user = await this.userService.getByAgentCode(this.code);
    if (!this.user) {
      this.sharedService.setHttpStatusCode(404);
      return;
    }
    this.criteria.AgentId = this.user.Id;
    this.setSeo();
    this.spinner.hide('load');
  }

  get title() {
    const title = this.user.Agent.Company;
    return title ? !title.includes('کاریابی') ? 'موسسه‌ی کاریابی ' + title : title : '';
  }
  private setSeo() {
    this.sharedService.setTitle(`${this.title} ${this.user.Agent.State}`);
    this.sharedService.removeLink('rel=\'canonical\'');
    this.sharedService.addLink({ rel: 'canonical', href: `${environment.app.url}/agent/${this.code}` });
    const keywords = ['کاریابی', this.user.Agent.Company, this.user.Name, 'دفتر مشاوره شغلی', 'مشاوره شغلی'];

    this.sharedService.setKeywordsMeta(...[<string>this.user.Agent.State, <string>this.user.Agent.City, ...keywords.slice(0, 10)]);
    this.sharedService.setDescriptionMeta(keywords.slice(0, 10).join(' | '));
  }

  hasDate(date: any) { return new PersianDate(date).year > 0; }
}
